import { Steps } from "antd";
import React, { useState } from "react";
import PatientBasicDetails from "./patientBasicDetails";
import RpmDetails from './providerDetails';
import ProgramInsurance from "./programAndInsurance";
import VitalConfiguration from "./vitalConfiguration";
import Devices from "./RpmDevices";

function Index({ handleCancel, handleSave }) {
  const [currPageView, setCurrPageView] = useState(1);

  const handleNext = () => {
    setCurrPageView((prevState) => prevState + 1);
  };

  const handlePrevious = () => {
    setCurrPageView((prevState) => prevState - 1);
  };

  return (
    <div className="pl-5">
      <Steps
        current={currPageView - 1}
        labelPlacement="vertical"
        className="m-4  w-100 text-brand-primaryColor cursor-pointer"
      >
        <PatientBasicDetails
          current={1}
          title={<span className="single-line-title">Basic Details</span>}
          // onClick={() => setCurrPageView(1)}
        />
        <RpmDetails
          current={1}
          title="Provider"
          className="whitespace-nowrap overflow-hidden overflow-ellipsis min-w-min"
          // onClick={() => setCurrPageView(2)}
        />
        <ProgramInsurance
          current={1}
          title={<span className="single-line-title">Program/Insurance</span>}
          // onClick={() => setCurrPageView(3)}
        />
        <VitalConfiguration
          current={1}
          title={<span className="single-line-title">Configuration</span>}
          // onClick={() => setCurrPageView(4)}
        />
        <Devices
          current={1}
          title={<span className="single-line-title">Devices</span>}
          // onClick={() => setCurrPageView(5)}
        />
      </Steps>
      <div className="disabled:cursor-not-allowed disabled:opacity-0">
        <div className={currPageView === 1 ? "block" : "hidden"}>
          <PatientBasicDetails
            handleCancel={handleCancel}
            handleSave={handleSave}
            handleNext={handleNext}
          />
        </div>

        <div className={currPageView === 2 ? "block" : "hidden"}>
          <RpmDetails
            currPageView={currPageView}
            handleCancel={handleCancel}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
          />
        </div>

        <div className={currPageView === 3 ? "block" : "hidden"}>
          <ProgramInsurance
            currPageView={currPageView}
            handleCancel={handleCancel}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
          />
        </div>

        <div className={currPageView === 4 ? "block" : "hidden"}>
          <VitalConfiguration
            currPageView={currPageView}
            handleCancel={handleCancel}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
          />
        </div>

        <div className={currPageView === 5 ? "block" : "hidden"}>
          <Devices
            currPageView={currPageView}
            handleCancel={handleCancel}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
          />
        </div>
      </div>
    </div>
  );
}

export default Index;
